import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noSpecialCharacters(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasSpecialCharacters = /[^a-zA-Z0-9ñÑ]/.test(control.value || '');
    return hasSpecialCharacters ? { noSpecialCharacters: true } : null;
  };
}
